<div class="save-cancel-button-row">
  <ng-container *ngIf="buttonConfig.showCancel">
    <button
      id="cancel-button"
      class="header-text"
      type="button"
      mat-button
      mat-dialog-close
    >
      {{ buttonConfig.cancel | uppercase }}
    </button>
  </ng-container>
  <button
    *ngIf="!showBlock"
    id="form-submit-button"
    class="header-text"
    type="submit"
    mat-button
    [mat-dialog-close]="true"
    cdkFocusInitial
    (click)="submit()"
    [disabled]="disableSubmit"
  >
    {{ buttonConfig.save | uppercase }}
  </button>
</div>
